import { render } from "./UserNewForm.vue?vue&type=template&id=6e8b4114"
import script from "./UserNewForm.vue?vue&type=script&lang=js"
export * from "./UserNewForm.vue?vue&type=script&lang=js"

import "./UserNewForm.vue?vue&type=style&index=0&id=6e8b4114&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__